import React from "react";
import ReactApexChart from "react-apexcharts";
import { fCurrency, fNumber } from "../../../../utils/formatNumber";

const RentStatisticChart = ({ chartData }) => {
  var OrderPriceData = [];

  if (chartData.OrderPriceDetails != null) {
    OrderPriceData = Array.from(chartData.OrderPriceDetails.split(","), String);
  }

  const series = [
    {
      name: "Net Price",
      //data: [200, 700, 500, 700, 600, 800, 500, 600, 900, 600, 400, 1000],
      data: OrderPriceData,
      //radius: 12,
    },
  ];

  const options = {
    chart: {
      height: 300,
      type: "line",
      toolbar: {
        show: false,
      },
    },

    colors: ["#32D16D"],
    dataLabels: {
      enabled: false,
    },

    legend: {
      show: false,
    },
    stroke: {
      show: true,
      width: 8,
      curve: "smooth",
      colors: ["#48A23F"],
    },

    grid: {
      show: true,
      borderColor: "#AFAFAF",
      strokeDashArray: 5,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          fontSize: "12px",
        },
      },
      crosshairs: {
        show: false,
        position: "front",
        stroke: {
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      show: true,
      labels: {
        offsetX: -15,
        formatter: function (value) {
          return fCurrency(value);
        },
      },
    },

    fill: {
      opacity: 1,
      colors: "#FB3E7A",
    },
    tooltip: {
      style: {
        fontSize: "12px",
      },
      y: {
        formatter: function (val) {
          // return "$" + val + " thousands";
          return fCurrency(val);
        },
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={300}
      />
    </div>
  );
};
export default RentStatisticChart;
